import {Button, Input, Popover, Select, Table, Tooltip, Tree, TreeSelect, Typography} from "antd";
import ShapeFileHelper from "../../Helpers/ShapeFileHelper";
import {Popup} from "react-leaflet";
import {useEffect, useRef, useState} from "react";

const FilterTitle = ({treeData, values, prop, onChangeFilters}) => {
    const [data, setData] = useState(treeData);
    const [search, setSearch] = useState('')
    const [filter, setFilter] = useState(values)

    const filterTreeNode = (input, treeNode) => {
        return true
    };

    const handleSearch = (search) => {
        if(!search)
        {
            setData(treeData)
            setSearch(search)
            return
        }

        const _data = treeData.filter(x =>
            x?.title?.toString()?.toLowerCase().includes(search.toLowerCase())
            ||  x?.value?.toString()?.toLowerCase().includes(search.toLowerCase())
        )

        setData(_data)
        setSearch(search)
    }

    return (
        <Popover
            placement={'bottomLeft'}
            trigger={'click'}
            content={(
                <div
                    style={{display: 'flex', alignItems: 'center', gap: 8, width: 800}}
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                    }}
                >
                    <TreeSelect
                        allowClear={true}
                        placeholder={'Filter'}
                        showSearch={true}
                        value={filter}
                        style={{width: '100%'}}
                        treeData={data}
                        treeCheckable={true}
                        filterTreeNode={false}
                        onSearch={handleSearch}
                        searchValue={search}
                        onChange={(values) => {
                            onChangeFilters && onChangeFilters(prop, values)
                            setFilter(values)
                        }}
                    />
                </div>
            )}
        >
            <Button
                size={'small'}
                style={{width: '100%'}}
                onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                }}
            >
                {prop}
            </Button>
        </Popover>
    )
}

export default function ShapeAttributeTable({geoJson, filters, onChangeFilters, onChange, bounding, selectable}) {
    const [data, setData] = useState([])

    const getColumns = () => {
        return ShapeFileHelper.getPropertyNames(geoJson).map(attr => ({
            key: attr,
            dataIndex: attr,
            sorter: (a, b) => {
                try {
                    if(typeof a[attr] === 'number' && typeof b[attr] === 'number') {
                        return a < b ? 1 : -1
                    }

                    return a[attr]?.toString()?.localeCompare(b[attr])
                }
                catch (exp) {
                    return 1
                }
            },
            title: (
                <>
                    {selectable && (
                        <FilterTitle
                            treeData={ShapeFileHelper.getDataGroup(geoJson, attr, bounding).map(x => ({title: x, value: x, key: x}))}
                            prop={attr}
                            values={filters[attr]}
                            onChangeFilters={(prop, values) => {
                                onChangeFilters && onChangeFilters(prop, values)
                                setData(getData())
                            }}
                        />
                    )}
                    {!selectable && attr}
                </>
            ),
            render: (text, row) => {
                if (text?.toString()?.length > 100) {
                    return (
                        <Tooltip
                            overlayInnerStyle={{
                                width: 500,
                                padding: 5,
                                overflowY: 'auto',
                                height: 300,
                                backgroundColor: 'black'
                            }}
                            title={() => {
                                return <div style={{}} dangerouslySetInnerHTML={{__html: text}}/>
                            }}
                            placement={'right'}
                        >
                            <Typography.Text ellipsis={true} style={{width: 100}}>{text}</Typography.Text>
                        </Tooltip>
                    )
                }

                return text
            }
        }))
    }

    const getData = () => {
        if(!selectable)
            return ShapeFileHelper.getAttributesData(geoJson)

        return ShapeFileHelper.getAttributesData(ShapeFileHelper.filterFeatures(geoJson, filters, bounding))
    }

    useEffect(() => {
        setData(getData())
    }, [geoJson, filters]);

    return (
        <>
            <Table
                scroll={{x: window.innerWidth*0.75}}
                size={'small'}
                dataSource={data}
                columns={getColumns()}
            />
        </>
    )
}